import { useQuery } from '@tanstack/react-query';
import { getTrialStatus } from '@/apis/auth';

/**
 * Hook to fetch trial status for a user
 * Returns trial information including IsInTrial, IsPaidUser, DaysRemaining, etc.
 */
export const useTrialStatus = (userUUID?: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['trialStatus', userUUID],
    queryFn: async () => {
      if (!userUUID) return null;
      const result = await getTrialStatus(userUUID);
      if (!result) return null;

      try {
        // Parse if it's a JSON string
        return typeof result === 'string' ? JSON.parse(result) : result;
      } catch (error) {
        console.error('useTrialStatus: Error parsing trial status:', error);
        return null;
      }
    },
    enabled: !!userUUID && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes - trial status doesn't change frequently
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    refetchOnWindowFocus: false,
  });
};

export type TrialStatus = {
  IsInTrial: boolean;
  IsPaidUser: boolean;
  DaysRemaining?: number;
  Error?: string;
};
